exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title_dialog[data-v-582f43b0] {\n  font-size: 26px;\n  font-weight: 600;\n  color: #fff;\n}\n.label_dialog[data-v-582f43b0] {\n  margin-bottom: 4px;\n  display: block;\n  font-weight: 500;\n  font-family: Arial, sans-serif;\n}\n", ""]);

// exports
